/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OwnerAndViewerList } from '../../models/owner-and-viewer-list';
import { UpdateOwnerAndViewerListDto } from '../../models/update-owner-and-viewer-list-dto';

export interface IlsControllerUpdateOwnerAndViewerList$Params {
  ilsId: string;
      body: UpdateOwnerAndViewerListDto
}

export function ilsControllerUpdateOwnerAndViewerList(http: HttpClient, rootUrl: string, params: IlsControllerUpdateOwnerAndViewerList$Params, context?: HttpContext): Observable<StrictHttpResponse<OwnerAndViewerList>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerUpdateOwnerAndViewerList.PATH, 'patch');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OwnerAndViewerList>;
    })
  );
}

ilsControllerUpdateOwnerAndViewerList.PATH = '/ils/{ilsId}/sharing';
